// extracted by mini-css-extract-plugin
module.exports = {"shareIcons":"_3l45zq","shareIconWithName":"_1Vz_To","icon":"PhFuH7","iconText":"LOLue-"};